export const TRAVEL_FUNNEL_BASE = "/devis-assurance-voyage"

// La tarification (motif, destination, dates, voyageurs) se fait désormais sur la landing
// (/guide/assurance-voyage) : le funnel démarre directement sur la page offres.
export const TRAVEL_STEPS = ["offres", "coordonnees", "details", "paiement"] as const
export type TravelStep = (typeof TRAVEL_STEPS)[number]

export const TRAVEL_SUBSCRIPTION_STEPS: TravelStep[] = ["coordonnees", "details", "paiement"]

export function isTravelStep(value: string): value is TravelStep {
    return (TRAVEL_STEPS as readonly string[]).includes(value)
}

export function travelStepUrl(token: string, step: TravelStep): string {
    return `${TRAVEL_FUNNEL_BASE}/${token}/${step}`
}

export function travelStepIndex(step: string): number {
    return (TRAVEL_STEPS as readonly string[]).indexOf(step)
}

// A travel quote only gets its prospect once the subscriber step is saved; that step records "details" before its PATCH resolves.
export function isTravelSubscriberSaved(step: TravelStep, recordedStep: TravelStep): boolean {
    return step !== "coordonnees" && travelStepIndex(recordedStep) > travelStepIndex("coordonnees")
}

export const TRAVEL_STEP_NAMES: Record<TravelStep, string> = {
    offres: "Nos offres",
    coordonnees: "Vos coordonnées",
    details: "Informations des voyageurs",
    paiement: "Paiement",
}

export interface TravelFunnelProgress {
    steps: TravelStep[]
    current: number
    name: string
}

// La souscription affiche « Étape X sur 3 » ; la page offres est hors étapes (pas de barre).
export function travelFunnelProgress(step: TravelStep): TravelFunnelProgress | null {
    if (!TRAVEL_SUBSCRIPTION_STEPS.includes(step)) {
        return null
    }

    return {
        steps: TRAVEL_SUBSCRIPTION_STEPS,
        current: TRAVEL_SUBSCRIPTION_STEPS.indexOf(step) + 1,
        name: TRAVEL_STEP_NAMES[step],
    }
}
